import axiosInstance from "../services/axiosInstance";

export const verifyEmailRegistrationToken = async (token) => {
  try {
    const response = await axiosInstance.get(
      `../verify/registration?token=${encodeURIComponent(token)}`,
    );

    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: 500,
        message: "An error occurred while verifying email.",
      }
    );
  }
};
